import { gradientConfig } from "../gradientConfig";

/**
 * Helper function that accepts an established gradient name as a parameter and returns its css style.
 *
 * @param {string} gradientName - Name of configured gradient to be displayed
 * @returns {string} Radial gradient css style
 */

export const getRadialGradient = (gradientName) => {
  let gradientStops = gradientConfig[gradientName];
  let gradientStyle;

  if (gradientStops) {
    gradientStops = gradientStops
      .map((stop) => `var(${stop.designToken}) ${stop.percentage}%`)
      .join(", ");

    gradientStyle = `radial-gradient(${gradientStops})`;
  }

  return gradientStops ? gradientStyle : "";
};
